import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import contactImg from "../img/R.jpg";

const ContactForm = () => {
  const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
const [resume, setResume] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    message: "",
    cource: "Java_FullStack_Developers", // default enum value
  });

  

  // Format date if backend needs specific format
  const formatDate = (date) => {
    if (!date) return "";
    return date;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleResumeUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResume(file);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const payload = new FormData();
  payload.append("name", formData.name);
  payload.append("email", formData.email);
  payload.append("phone", formData.phone);
  payload.append("gender", formData.gender);
  payload.append("cource", formData.cource);
  payload.append("dob", formatDate(formData.dob));
  payload.append("message", formData.message);

  if (resume) {
    payload.append("attachment", resume);
  }

  try {
    const response = await fetch(
      "https://backend.maamaas.com/iia/api/enquiry",
      {
        method: "POST",
        body: payload,
      }
    );

    let data;
    const text = await response.text();

    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text };
    }

    if (!response.ok) {
      throw new Error(data.message || "Submission failed");
    }

    alert(data.message || "Enquiry submitted successfully ✅");

    setFormData({
      name: "",
      email: "",
      phone: "",
      dob: "",
      gender: "",
      message: "",
      cource: "Java_FullStack_Developers",
    });

    setResume(null);
  } catch (error) {
    console.error(error);
    alert(error.message || "Server or CORS Error ❌");
  } finally {
    setLoading(false);
  }
};

  const inputStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    marginBottom: "15px",
  };

  return (
    <section style={{ padding: "20px" }}>
      <div className="container-fluid">
        <div style={{ marginTop: "60px" }}>
             <h2
              style={{
                textAlign: "center",
                fontFamily: "Roboto",
                marginBottom: "20px",
                fontSize: "22px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              Welcome to{" "}
              <span style={{ color: "white" }}>
                International Institute of{" "}
              </span>
              <span style={{ color: "orange" }}>Automate</span>
            </h2>
          </div>
        <div className="row p-3-vh">

          {/* LEFT IMAGE WITH OVERLAY */}
          <div className="col-md-6 mb-4">
            <div style={{ position: "relative" }}>
              
              {/* Back Button */}
              <button
                onClick={() => navigate("/Secondactiveprograms")}
                style={{
                  position: "absolute",
                  top: "15px",
                  left: "15px",
                  background: "rgba(248, 156, 8, 0.87)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "20px",
                  cursor: "pointer",
                  zIndex: 2,
                }}
              >
                ←
              </button>

              {/* Course Name */}

<div
  style={{
    position: "absolute",
    bottom: "230px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "rgba(248, 156, 8, 0.87)",
    color: "#fff",

    width: "90%",
    maxWidth: "900px",

    padding: "20px 40px",
    borderRadius: "10px",

    fontSize: "clamp(16px, 2.2vw, 24px)",
    fontWeight: "900",
    textAlign: "center",
    lineHeight: "1.4",
    letterSpacing: "0.6px",

    zIndex: 2,
  }}
>
  Industry Insights on Java Full-Stack
</div>



              <img
                src={contactImg}
                alt="Robotic Virtual Simulation"
                style={{
                  width: "100%",
                  height: "560px",
                  objectFit: "cover",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="col-md-6">
            <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        backgroundColor: "#eef6fc",
        padding: "30px",
        borderRadius: "6px",
      }}
    >
      <input
        id="name"
        placeholder="Name"
        required
        value={formData.name}
        onChange={handleChange}
        style={inputStyle}
      />

      <input
        id="email"
        type="email"
        placeholder="Email"
        required
        value={formData.email}
        onChange={handleChange}
        style={inputStyle}
      />

      <input
        id="phone"
        placeholder="Phone"
        required
        value={formData.phone}
        onChange={handleChange}
        style={inputStyle}
      />

      <input
        id="dob"
        type="date"
        required
        value={formData.dob}
        onChange={handleChange}
        style={inputStyle}
      />

      <select
        id="gender"
        required
        value={formData.gender}
        onChange={handleChange}
        style={inputStyle}
      >
        <option value="">Select Gender</option>
        <option value="MALE">Male</option>
        <option value="FEMALE">Female</option>
        <option value="OTHER">Other</option>
      </select>

      <input
        type="file"
        accept=".pdf,.doc,.docx"
        onChange={handleResumeUpload}
        style={inputStyle}
      />

      <textarea
        id="message"
        rows="4"
        placeholder="Enter your message"
        required
        value={formData.message}
        onChange={handleChange}
        style={inputStyle}
      />

      <button
        type="submit"
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px",
          background: "#0047ff",
          color: "#fff",
          border: "none",
          borderRadius: "25px",
          fontSize: "16px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        {loading ? "Submitting..." : "SEND ENQUIRY"}
      </button>
    </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;



